<script lang="ts">
    
    import type { Section } from "../../Model/Section";
    import Watch from "../Watch.svelte";
    import QuestionAnswer from "./QuestionAnswer.svelte";

    export let section: Section;

</script>

<div class="border rounded mb-3 p-3">
    <h5>
        <Watch store={section.name} />
    </h5>
    {#each section.questions as question}
        <QuestionAnswer {question} />
    {/each}
</div>
